// Построители микроразметки schema.org. Единственный источник для двух
// потребителей: пререндера (scripts/seo-template.js) и SPA (App.vue через
// vue-meta). Раньше Organization и WebSite были захардкожены в шаблоне — с
// появлением разметки в приложении это стало бы двумя копиями, которые
// разъедутся.
//
// CommonJS, как и реестр: файл читают и webpack, и node-скрипт сборки.
// Константы берём из site.js, а не из pages.js: реестр сам зовёт эти
// построители, и ссылка на него замкнула бы цикл.
const { SITE, DEFAULT_OG_IMAGE, ORG_LOGO } = require('./site')

const ORG_ID = `${SITE}/#organization`
const WEBSITE_ID = `${SITE}/#website`

// Организация и сайт одинаковы на всех страницах. Связаны по @id, чтобы
// поисковики склеивали их с постраничными Breadcrumb и Product.
const organization = () => ({
  '@context': 'https://schema.org',
  '@type': 'OnlineStore',
  '@id': ORG_ID,
  name: 'RbxPier.me',
  url: `${SITE}/`,
  logo: ORG_LOGO,
  description:
    'Покупка робуксов Roblox: трансфер, подарочные карты, супер-пассы и робукс паки. Быстро, дёшево и безопасно. Работаем с 2018 года.',
  sameAs: ['https://t.me/robuxpier', 'https://vk.com/robuxpier', 'https://www.youtube.com/@robuxpier']
})

const website = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  name: 'RbxPier.me',
  url: `${SITE}/`,
  inLanguage: 'ru-RU',
  publisher: { '@id': ORG_ID }
})

/** items: [{ name, url }] — url относительный, от корня. */
const breadcrumbs = items => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${SITE}${item.url}`
  }))
})

/**
 * Товарная разметка money-страницы.
 * prices: [{ amount, price }] либо null, если цены недоступны.
 *
 * Без цен блок offers не выводим вовсе: lowPrice — обязательное поле
 * AggregateOffer, и без него Google отдаёт «Missing field lowPrice», а сниппет
 * не показывается. Product без offers ошибки не даёт (опыт Дерева).
 */
const product = ({ name, description, url, image, prices }) => {
  const values = (prices || []).map(item => item.price).filter(price => price > 0)

  const offers = values.length
    ? {
      '@type': 'AggregateOffer',
      priceCurrency: 'RUB',
      availability: 'https://schema.org/InStock',
      url: `${SITE}${url}`,
      seller: { '@id': ORG_ID },
      lowPrice: Math.min(...values),
      highPrice: Math.max(...values),
      offerCount: values.length
    }
    : undefined

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    description,
    url: `${SITE}${url}`,
    image: image || DEFAULT_OG_IMAGE,
    brand: { '@type': 'Brand', name: 'RbxPier.me' },
    category: 'Roblox',
    ...(offers ? { offers } : {})
  }
}

module.exports = { ORG_ID, WEBSITE_ID, organization, website, breadcrumbs, product }
